import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store/store';



export const selectApiErrors = (state: RootState) => state.advancedErrors.apiErrors;



export const selectShowErrorModal = createSelector(selectApiErrors, a => a && a.length > 0);